import AppHistory from "shared/history"
import Routes from "shared/routes"

export default function redirectBack({defaultPath, queryParams}) {
  const pathName = queryParams.back_to || defaultPath

  AppHistory.push(Routes[`${pathName}Path`]())
}
